export default "__VITE_ASSET__BkUVnxO8__"